import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import moment from "moment";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { useWebAppFooter } from "../MainNavigation.hook";
import { fields, fieldsReady } from "../constants";

export const WebAppFooter = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [fieldData, setFieldData] = useState<any>();
  
    async function fetchData() {
      await fieldsReady;
  
      setFieldData(fields);
    }
  useEffect(() => {
    fetchData();
  }, [])

  const { data: editData, error, isLoading: drilldownLoading, isError, refetch: refetchEditData } = useWebAppFooter();

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    refetchEditData();
  }, []);

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
  }, [query.get("id")]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      field_copyright_text_en: dataById
        ? decodeHTML(dataById.payload.field_copyright_text_en)
        : editData
          ? decodeHTML(editData?.field_copyright_text_en)
          : "",
      field_copyright_text_ms: dataById
        ? decodeHTML(dataById.payload.field_copyright_text_ms)
        : editData
          ? decodeHTML(editData.field_copyright_text_ms)
          : "",
      field_copyright_text_zh: dataById
        ? decodeHTML(dataById.payload.field_copyright_text_zh)
        : editData
          ? decodeHTML(editData?.field_copyright_text_zh)
          : "",
      field_registration_number_txt_en: dataById
        ? decodeHTML(dataById.payload.field_registration_number_txt_en)
        : editData
          ? decodeHTML(editData?.field_registration_number_txt_en)
          : "",
      field_registration_number_txt_ms: dataById
        ? decodeHTML(dataById.payload.field_registration_number_txt_ms)
        : editData
          ? decodeHTML(editData.field_registration_number_txt_ms)
          : "",
      field_registration_number_txt_zh: dataById
        ? decodeHTML(dataById.payload.field_registration_number_txt_zh)
        : editData
          ? decodeHTML(editData?.field_registration_number_txt_zh)
          : "",
      field_mobile_app_text_en: dataById
        ? decodeHTML(dataById.payload.field_mobile_app_text_en)
        : editData
          ? decodeHTML(editData?.field_mobile_app_text_en)
          : "",
      field_mobile_app_text_ms: dataById
        ? decodeHTML(dataById.payload.field_mobile_app_text_ms)
        : editData
          ? decodeHTML(editData.field_mobile_app_text_ms)
          : "",
      field_mobile_app_text_zh: dataById
        ? decodeHTML(dataById.payload.field_mobile_app_text_zh)
        : editData
          ? decodeHTML(editData?.field_mobile_app_text_zh)
          : "",
      field_term_of_use_text_en: dataById
        ? decodeHTML(dataById.payload.field_term_of_use_text_en)
        : editData
          ? decodeHTML(editData?.field_term_of_use_text_en)
          : "",
      field_term_of_use_text_zh: dataById
        ? decodeHTML(dataById.payload.field_term_of_use_text_zh)
        : editData
          ? decodeHTML(editData.field_term_of_use_text_zh)
          : "",
      field_term_of_use_text_ms: dataById
        ? decodeHTML(dataById.payload.field_term_of_use_text_ms)
        : editData
          ? decodeHTML(editData?.field_term_of_use_text_ms)
          : "",
      termsOfUseLink: dataById
        ? decodeHTML(dataById.payload.termsOfUseLink)
        : editData
          ? decodeHTML(editData.termsOfUseLink)
          : "",
      field_privacy_policy_text_en: dataById
        ? decodeHTML(dataById.payload.field_privacy_policy_text_en)
        : editData
          ? decodeHTML(editData?.field_privacy_policy_text_en)
          : "",
      field_privacy_policy_text_ms: dataById
        ? decodeHTML(dataById.payload.field_privacy_policy_text_ms)
        : editData
          ? decodeHTML(editData.field_privacy_policy_text_ms)
          : "",
      field_privacy_policy_text_zh: dataById
        ? decodeHTML(dataById.payload.field_privacy_policy_text_zh)
        : editData
          ? decodeHTML(editData?.field_privacy_policy_text_zh)
          : "",
      privacyPolicyLink: dataById
        ? decodeHTML(dataById.payload.privacyPolicyLink)
        : editData
          ? decodeHTML(editData.privacyPolicyLink)
          : "",
      playStoreImage: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "playStoreImage.png",
              status: "done",
              url: dataById?.payload?.playStoreImage,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "playStoreImage.png",
              status: "done",
              url: editData?.playStoreImage,
            },
          ]),
      appStoreImage: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "appStoreImage.png",
              status: "done",
              url: dataById?.payload?.appStoreImage,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "appStoreImage.png",
              status: "done",
              url: editData?.appStoreImage,
            },
          ]),
      playStoreLink: dataById
        ? decodeHTML(dataById.payload.playStoreLink)
        : editData
          ? decodeHTML(editData?.playStoreLink)
          : "",
      appStoreLink: dataById
        ? decodeHTML(dataById.payload.appStoreLink)
        : editData
          ? decodeHTML(editData.appStoreLink)
          : "",
    },
    fields: fieldData?.aboutAndLegal,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["appStoreImage", "playStoreImage"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    let dateKeys: any = ["date"];
    for (const key of dateKeys) {
      if (data[key]) {
        data[key] = moment(data[key]).format("DD MMM YYYY");
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Navigation",
      subModule: "webAppFooter_aboutAndLegal",
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Navigation",
      payload: {
        ...(action === "UPDATE" && { id: editData?.id || dataById?.payload?.id }),
        ...data,
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <DynamicForm
      isLoading={isLoadingData || drilldownLoading}
      config={AwardsFormConfig}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${corporateHost}/api/web-app-footer/${editData?.id || dataById?.payload?.id || ""}`,
          "UPDATE",
          "PATCH",
          buttonValue == "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
      defaultReviewNotes="Kindly review this Navigation"
    />
  );
};
